import { render, staticRenderFns } from "./DialogHelpCenter.vue?vue&type=template&id=60b55572&scoped=true&"
import script from "./DialogHelpCenter.vue?vue&type=script&lang=js&"
export * from "./DialogHelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./DialogHelpCenter.vue?vue&type=style&index=0&id=60b55572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b55572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
